import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Table.scss';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { isNil } from 'lodash-es';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import * as yup from 'yup';
import { QRCodeSVG } from 'qrcode.react';
import loader from '../../../assets/lotties/loader.json';
import { useCreateTableMutation, useGetTableByIdQuery, useUpdateTableMutation } from '../../../store/table/tableApi';
import { IGetTableResponse } from '../../../proto/table/table';

type Inputs = {
	name: string;
};

const schema = yup.object({
	name: yup.string().required('Table name is required'),
});

export const Table = (): JSX.Element => {
	const { id: tableId } = useParams<{ id?: string }>();
	const { data: table, isLoading: isLoadingTable } = useGetTableByIdQuery(tableId, { skip: isNil(tableId) });
	const [createTable] = useCreateTableMutation();
	const [updateTable] = useUpdateTableMutation();
	const navigate = useNavigate();

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm<Inputs>({
		resolver: yupResolver(schema), // connect yup
		defaultValues: {
			name: table?.name || '',
		},
	});

	// hydrate the form once table data is fetched
	useEffect(() => {
		if (!isNil(table)) {
			reset({
				name: table.name ?? '',
			});
		}
	}, [table, reset]);

	const upsertTable = async (data: Inputs): Promise<IGetTableResponse> => {
		if (!isNil(tableId)) {
			return updateTable({ id: tableId, ...data }).unwrap();
		}

		return createTable(data).unwrap();
	};

	const onFormSubmit: SubmitHandler<Inputs> = (data) => {
		upsertTable(data)
			.then((res) => {
				console.log('table updated:', res);
				const status = isNil(tableId) ? 'נוסף' : 'עודכן';

				toast.success(`השולחן ${status} בהצלחה`);
				navigate('/restaurantManagement/tables');
			})
			.catch((err) => {
				console.error('Failed to update table:', err);
				toast.error('שגיאת עדכון');
			});
	};

	return (
		<div className="tableContainer">
			{isLoadingTable ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<>
					<form onSubmit={handleSubmit(onFormSubmit)}>
						<div className="formGroup">
							<label>שם השולחן</label>
							<input {...register('name')} />
							{errors.name && <p style={{ color: 'red' }}>{errors.name.message}</p>}
						</div>
						<button type="submit">שמור</button>
					</form>
					<div className="qrContainer">
						<span>קוד QR</span>
						<QRCodeSVG value={`${process.env.REACT_APP_CLIENT_URL}/?tableId=${tableId}`} />
					</div>
				</>
			)}
		</div>
	);
};
